import {AlbumSummary} from './AlbumSummary';
import {AlbumNavigationMap} from './AlbumNavigationMap';

export class AlbumNavigation {
  albumNavigationMap: AlbumNavigationMap = new AlbumNavigationMap();

  deserialize(albumsForArtist: Array<AlbumSummary>): void {
    this.albumNavigationMap.buildNavigation(albumsForArtist);
  }

}
